import apiZelo from '../backAxiosVendaToken';

class ComprovanteService {
    async geraComprovanteAdesao(bodyComprovanteAdesao) {
        try {
            const boleto = await apiZelo.post(
                '/pdf/adesao',
                bodyComprovanteAdesao
            );

            return boleto.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default new ComprovanteService();
